/* ISCA - Name embroidery.

   Two-step flow by necessity: the size grid adds the garments, this adds the
   names. Guarded so nobody pays for a name with nothing to stitch it onto:
     - no garments of this product in the basket -> refuse, say what to do first
     - fewer garments than names                 -> warn, allow on purpose

   On success we go to /cart. The theme's cart drawer is rendered server-side at
   page load, so an AJAX add leaves it showing a stale, often empty cart - which
   reads as "nothing was added" even when it worked.

   markStepOne() badges the size grid to match this panel, so the two read as
   one sequence. Only runs when a name panel is actually on the page. */

(function () {
  function markStepOne() {
    if (!document.querySelector('.isca-ne')) return;

    var grid = document.querySelector('[id^="sqg-"]');
    if (!grid || grid.dataset.iscaStepped === '1') return;

    var h = grid.querySelector('h1, h2, h3, h4');
    if (!h || !h.parentNode) return;

    grid.dataset.iscaStepped = '1';

    var badge = document.createElement('span');
    badge.className = 'isca-ne__step';
    badge.textContent = 'Step 1 of 2';
    h.parentNode.insertBefore(badge, h);
  }

  function init(root) {
    if (!root || root.dataset.iscaNeReady === '1') return;
    root.dataset.iscaNeReady = '1';

    var VARIANT = root.dataset.variantId;
    var PRODUCT_ID = Number(root.dataset.productId || '0');
    var UNIT = parseFloat(root.dataset.unitPrice || '100') / 100;
    var GARMENT = root.dataset.garment || '';
    var MAXLEN = parseInt(root.dataset.maxLen, 10) || 20;

    var SIZES = [];
    try { SIZES = JSON.parse(root.dataset.sizes || '[]'); } catch (e) { SIZES = []; }
    var single = SIZES.length === 1;

    var toggle = root.querySelector('[data-ne-toggle]');
    var panel = root.querySelector('[data-ne-panel]');
    var rows = root.querySelector('[data-ne-rows]');
    var another = root.querySelector('[data-ne-another]');
    var addBtn = root.querySelector('[data-ne-add]');
    var totalEl = root.querySelector('[data-ne-total]');
    var msg = root.querySelector('[data-ne-msg]');

    if (!toggle || !rows || !addBtn) return;

    function money(n) { return '£' + n.toFixed(2); }

    function esc(s) {
      return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
    }

    function opts() {
      var h = single ? '' : '<option value="">Choose…</option>';
      SIZES.forEach(function (s) { h += '<option value="' + esc(s) + '">' + esc(s) + '</option>'; });
      return h;
    }

    function addRow() {
      var row = document.createElement('div');
      row.className = 'isca-ne__row';
      row.innerHTML =
        '<div class="isca-ne__field isca-ne__field--name"><label>Name on garment</label>' +
        '<input type="text" data-ne-name maxlength="' + MAXLEN + '" placeholder="e.g. A. Lindsey" autocomplete="off"></div>' +
        '<div class="isca-ne__field isca-ne__field--size"><label>Size</label>' +
        '<select data-ne-size>' + opts() + '</select></div>' +
        '<div class="isca-ne__field isca-ne__field--qty"><label>Qty</label>' +
        '<input type="number" data-ne-qty value="1" min="1" max="30" inputmode="numeric"></div>' +
        '<button type="button" class="isca-ne__remove" data-ne-remove aria-label="Remove this name">&times;</button>';
      rows.appendChild(row);
      refresh();
    }

    function scan() {
      var ok = [], missing = 0;
      rows.querySelectorAll('.isca-ne__row').forEach(function (row) {
        var nameEl = row.querySelector('[data-ne-name]');
        var sizeEl = row.querySelector('[data-ne-size]');
        var name = (nameEl.value || '').trim();
        var size = sizeEl.value || '';
        var qty = parseInt(row.querySelector('[data-ne-qty]').value, 10);
        if (!qty || qty < 1) qty = 1;

        if (name && !size) {
          missing++;
          sizeEl.classList.add('is-missing');
        } else {
          sizeEl.classList.remove('is-missing');
          if (name && size) ok.push({ name: name, size: size, qty: qty });
        }
      });
      return { ok: ok, missing: missing };
    }

    function refresh() {
      var r = scan();
      var count = r.ok.reduce(function (a, e) { return a + e.qty; }, 0);
      addBtn.disabled = r.ok.length === 0 || r.missing > 0;

      if (r.missing > 0) {
        totalEl.textContent = 'Choose a size for each name';
      } else {
        totalEl.textContent = count
          ? money(count * UNIT) + ' for ' + count + (count === 1 ? ' garment' : ' garments')
          : '';
      }
    }

    function say(text, kind) {
      msg.className = 'isca-ne__msg isca-ne__msg--' + kind;
      msg.innerHTML = text;
      msg.hidden = false;
    }

    toggle.addEventListener('change', function () {
      panel.hidden = !toggle.checked;
      if (toggle.checked && !rows.children.length) addRow();
      if (toggle.checked) {
        var f = rows.querySelector('[data-ne-name]');
        if (f) f.focus();
      }
    });

    another.addEventListener('click', addRow);
    rows.addEventListener('input', refresh);
    rows.addEventListener('change', refresh);

    rows.addEventListener('click', function (e) {
      if (e.target.closest('[data-ne-remove]') && rows.children.length > 1) {
        e.target.closest('.isca-ne__row').remove();
        refresh();
      }
    });

    function reset() {
      addBtn.textContent = 'Add names to basket';
      addBtn.disabled = false;
    }

    function send(items) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) {
          return res.json().then(function (data) {
            if (!res.ok) throw new Error(data.description || data.message || ('Shopify returned ' + res.status));
            return data;
          });
        })
        .then(function () {
          say('Added — taking you to your basket…', 'ok');
          window.location.href = '/cart';
        })
        .catch(function (err) {
          say('Could not add that: ' + (err.message || 'unknown error') + '. Nothing has been charged.', 'err');
          reset();
        });
    }

    addBtn.addEventListener('click', function () {
      var r = scan();
      if (!r.ok.length || r.missing > 0) { refresh(); return; }

      if (!VARIANT || isNaN(Number(VARIANT))) {
        say('Setup problem: the £1 add-on product was not found. Nothing has been charged.', 'err');
        return;
      }

      addBtn.disabled = true;
      addBtn.textContent = 'Checking…';
      msg.hidden = true;

      var wanted = r.ok.reduce(function (a, e) { return a + e.qty; }, 0);

      var items = r.ok.map(function (e) {
        return {
          id: Number(VARIANT),
          quantity: e.qty,
          properties: { 'Name': e.name, 'Size': e.size, 'Garment': GARMENT }
        };
      });

      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          var inCart = 0;
          (cart.items || []).forEach(function (line) {
            if (PRODUCT_ID && line.product_id === PRODUCT_ID) inCart += line.quantity;
          });

          if (PRODUCT_ID && inCart === 0) {
            say(
              '<strong>Add the garments first.</strong><br>' +
              'Go up to <em>Step 1</em>, choose your sizes and press <em>Add to Basket</em>, then come back ' +
              'and add the names. Names on their own would arrive with nothing to stitch them onto.',
              'warn'
            );
            reset();
            return;
          }

          if (PRODUCT_ID && wanted > inCart) {
            say(
              '<strong>Check this before you continue.</strong><br>' +
              'You have asked for <strong>' + wanted + '</strong> name' + (wanted === 1 ? '' : 's') +
              ' but only <strong>' + inCart + '</strong> of this garment ' + (inCart === 1 ? 'is' : 'are') +
              ' in your basket. Add more in Step 1, or carry on if that is what you meant.' +
              '<br><button type="button" class="isca-ne__anyway" data-ne-anyway>Add the names anyway</button>',
              'warn'
            );
            reset();

            var anyway = msg.querySelector('[data-ne-anyway]');
            if (anyway) {
              anyway.addEventListener('click', function () {
                addBtn.disabled = true;
                addBtn.textContent = 'Adding…';
                msg.hidden = true;
                send(items);
              });
            }
            return;
          }

          addBtn.textContent = 'Adding…';
          return send(items);
        })
        .catch(function () {
          addBtn.textContent = 'Adding…';
          return send(items);
        });
    });

    refresh();
  }

  function boot() {
    document.querySelectorAll('.isca-ne').forEach(init);
    markStepOne();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:block:select', boot);
})();
